export default "__VITE_ASSET__BSMJeCyc__"